import React, {useContext} from 'react';
import {FormattedMessage} from "react-intl";

import SidebarItem from "../../../SidebarItem";

import {Authorizations, hasAuthorization} from "utils/authorizations";
import {OMSRoutes} from "utils/OMSRoutes";

import {ReactComponent as ClipboardExportIcon} from "assets/img/clipboard-export.svg";

import {SidebarContext} from "../../../../../../SidebarContext";

function QuotesStatisticsItem(props) {
    const {currentPath, currentMemberAuthorizations} = useContext(SidebarContext);

    if (!hasAuthorization(currentMemberAuthorizations, Authorizations.PICKING_STATISTICS_QUOTES)) {
        return null;
    }

    const isSelected = currentPath.startsWith(OMSRoutes.QUOTES_STATISTICS);

    return (
        <SidebarItem
            isTopLevel
            icon={<ClipboardExportIcon />}
            to={OMSRoutes.QUOTES_STATISTICS}
            selected={isSelected}
        >
            <FormattedMessage id='sidebar.item.dashboard.quotes' />
        </SidebarItem>
    );
}

export default QuotesStatisticsItem;
